import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntKategorie: SelectDataObject[] = [
    { i: 0, t: '(unbekannt)' },
    { i: 10, t: 'PKW' },
    { i: 40, t: 'LKW' },
    { i: 51, t: 'Reisemobil' },
    { i: 52, t: 'Caravan' },
    { i: 60, t: 'Motorrad' },
    { i: 70, t: 'Anhänger' },
    { i: 80, t: 'Transporter' },
    { i: 100, t: 'Sattelzugmaschine' },
    { i: 101, t: 'Auflieger' },
    { i: 102, t: 'Baumaschine' },
    { i: 103, t: 'Bus' },
    { i: 104, t: 'Agrarfahrzeug' },
    { i: 105, t: 'Stapler' },
];
export default sIntKategorie;
